function Spinner() {
  return <span className="spinner loader" />;
}

export default Spinner;
